import React from 'react'
import createMarkup from '../../../helpers/createMarkup'
import { Row, Col } from 'reactstrap'

export default function ItemQuestion(props) {
  let markup
  let output = <div></div>
  if (props.question) {
    markup = createMarkup(props.question)
    output = <div dangerouslySetInnerHTML={markup}></div>
  }

  return (
    <Row>
      <Col>
        <div style={{"fontSize":props.fontValue}} dangerouslySetInnerHTML={markup}></div>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemQuestion.js